import { render, staticRenderFns } from "./WellbeingQuestions.vue?vue&type=template&id=9cac3054&scoped=true&"
import script from "./WellbeingQuestions.vue?vue&type=script&lang=js&"
export * from "./WellbeingQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cac3054",
  null
  
)

export default component.exports